import { ThunkApiType } from 'types/utils';
import authFetch, { checkForUnauthorizedResponse } from 'utils/axios';

export const getCarriersThunk = async (_: string, thunkAPI: ThunkApiType) => {
	const getCarriersURL = '/carriers/domain';

	try {
		const response = await authFetch.get(getCarriersURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getGroupsThunk = async (_: string, thunkAPI: ThunkApiType) => {
	const getGroupsURL = '/groups/domain';

	try {
		const response = await authFetch.get(getGroupsURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getClaimsStatusesThunk = async (
	_: string,
	thunkAPI: ThunkApiType,
) => {
	let getClaimsStatusesURL = '/claim/status';

	try {
		const response = await authFetch.get(getClaimsStatusesURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getClientsThunk = async (_: string, thunkAPI: ThunkApiType) => {
	const getClientsURL = '/clients/domain';

	try {
		const response = await authFetch.get(getClientsURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getReturnStatusesThunk = async (
	_: object,
	thunkAPI: ThunkApiType,
) => {
	try {
		const response = await authFetch.get(`returns/statuses`);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getNetworksThunk = async (_: string, thunkAPI: ThunkApiType) => {
	const getNetworksURL = '/networks';

	try {
		const response = await authFetch.get(getNetworksURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getComplaintStatusesThunk = async (
	_: string,
	thunkAPI: ThunkApiType,
) => {
	const getComplaintStatusesURL = '/complaints/statuses';

	try {
		const response = await authFetch.get(getComplaintStatusesURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getComplaintSourcesThunk = async (
	_: string,
	thunkAPI: ThunkApiType,
) => {
	const getComplaintSourcesURL = '/complaints/sources';

	try {
		const response = await authFetch.get(getComplaintSourcesURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getComplaintTypeThunk = async (
	_: string,
	thunkAPI: ThunkApiType,
) => {
	const getComplaintTypesURL = '/complaints/types';

	try {
		const response = await authFetch.get(getComplaintTypesURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getFraudStatusesThunk = async (
	_: string,
	thunkAPI: ThunkApiType,
) => {
	const getFraudStatusesURL = '/frauds/statuses';

	try {
		const response = await authFetch.get(getFraudStatusesURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getRelationshipTypesThunk = async (
	_: string,
	thunkAPI: ThunkApiType,
) => {
	const getRelationshipTypesURL = '/relationship/domain';

	try {
		const response = await authFetch.get(getRelationshipTypesURL);
		return response.data.map((item: { code: string; label: string }) => ({
			code: item.code,
			name: item.code, // this is set as code because we want to see the code in the dropdown instead of the label
		}));
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};
